import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withSignUp } from '../SignUpContext';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import { SignUpLayout } from '../user/SignUpLayout';
import { Paper } from '../../../components/paper/Paper';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = {
  email: string;
};

export class RawSignUpMailConfirmation extends React.Component<Props> {
  render() {
    return (
      <SignUpLayout>
        <PageContainer classNames="signup-card">
          <Page>
            <Paper level={0} className="signup-card__container center">
              <MaterialIcon name="mail_outline" className="signup-card__icon" />
              <div className="signup-card__title">
                <FormattedMessage id="signup/routes/mail/SignUpMailConfirmation.tsx/1" />
              </div>
              <p className="signup-card__subtitle2">
                <FormattedMessage id="signup/routes/mail/SignUpMailConfirmation.tsx/2" />{' '}
                <b>{this.props.email}</b>{' '}
                <FormattedMessage id="signup/routes/mail/SignUpMailConfirmation.tsx/3" />
              </p>
            </Paper>
          </Page>
        </PageContainer>
      </SignUpLayout>
    );
  }
}

export const SignUpMailConfirmation = withSignUp(RawSignUpMailConfirmation);
